import { render, staticRenderFns } from "./_posts.vue?vue&type=template&id=2dc49cd5"
import script from "./_posts.vue?vue&type=script&lang=js"
export * from "./_posts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports